/* Halloween version of the Activity Centre spot the difference (sections/bb-spot-difference.liquid,
   Picture setting = "Halloween night"). Self-contained so the main bb-activities.js stays unchanged. */
(function () {
  'use strict';
  var SVGNS = 'http://www.w3.org/2000/svg';
  var INK = '#2E1A5C';
  function el(tag, attrs) {
    var n = document.createElementNS(SVGNS, tag);
    for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]);
    return n;
  }

  /* Halloween night scene: moon, bats, a friendly ghost, pumpkins and a spider */
  function sceneHalloween(changed) {
    var svg = el('svg', { viewBox: '0 0 300 220', role: 'img', 'aria-label': (changed ? 'Picture B' : 'Picture A') + ': a spooky Halloween night' });
    function add(tag, attrs) {
      if (!attrs.stroke) attrs.stroke = INK;
      attrs['stroke-width'] = attrs['stroke-width'] === undefined ? 2.5 : attrs['stroke-width'];
      attrs['stroke-linejoin'] = 'round'; attrs['stroke-linecap'] = 'round';
      svg.appendChild(el(tag, attrs));
    }
    function bat(x, y) {
      add('path', { d: 'M' + (x - 22) + ' ' + y + ' q7 -12 13 -3 q3 -9 9 -3 q6 -6 9 3 q6 -9 13 3 q-9 -2 -11 7 q-4 -5 -11 -1 q-7 -4 -11 1 q-2 -9 -11 -7z', fill: '#1B0F36', stroke: '#1B0F36', 'stroke-width': 1.5 });
      add('circle', { cx: x - 3, cy: y - 2, r: 1.4, fill: '#FFD43B', 'stroke-width': 0 });
      add('circle', { cx: x + 3, cy: y - 2, r: 1.4, fill: '#FFD43B', 'stroke-width': 0 });
    }
    function pumpkin(x, y, r, colour) {
      add('rect', { x: x - 3, y: y - r - 8, width: 6, height: 11, rx: 2, fill: '#3BB273' });
      add('ellipse', { cx: x, cy: y, rx: r * 1.2, ry: r, fill: colour });
      add('path', { d: 'M' + x + ' ' + (y - r) + ' q-' + (r * 0.5) + ' ' + r + ' 0 ' + (r * 2), fill: 'none', 'stroke-width': 1.5 });
      add('path', { d: 'M' + (x - r * 0.55) + ' ' + (y - 3) + ' l5 -8 5 8z', fill: '#FFD43B', 'stroke-width': 1.5 });
      add('path', { d: 'M' + (x + r * 0.55 - 10) + ' ' + (y - 3) + ' l5 -8 5 8z', fill: '#FFD43B', 'stroke-width': 1.5 });
      add('path', { d: 'M' + (x - r * 0.6) + ' ' + (y + 6) + ' q' + (r * 0.6) + ' ' + (r * 0.55) + ' ' + (r * 1.2) + ' 0', fill: 'none', stroke: '#FFD43B', 'stroke-width': 3 });
    }
    // night sky, stars and hill
    add('rect', { x: 0, y: 0, width: 300, height: 220, fill: '#3A2373', 'stroke-width': 0 });
    [[22, 24], [96, 18], [140, 92], [206, 22], [284, 96], [30, 96]].forEach(function (s) {
      add('circle', { cx: s[0], cy: s[1], r: 1.8, fill: '#FFFFFF', 'stroke-width': 0 });
    });
    add('path', { d: 'M0 168 q80 -26 160 -6 q80 18 140 -4 v62 h-300z', fill: '#2B6B4A', 'stroke-width': 0 });
    add('circle', { cx: 246, cy: 46, r: 24, fill: changed ? '#FF9F1C' : '#FFF3B0' });                 // 1 moon colour
    add('circle', { cx: 238, cy: 40, r: 4, fill: 'none', stroke: 'rgba(46,26,92,.35)', 'stroke-width': 2 });
    bat(70, 58);
    if (!changed) bat(178, 70);                                                                         // 2 missing bat
    if (changed) {                                                                                      // 5 extra spider
      add('path', { d: 'M118 0 v50', fill: 'none', stroke: '#FFFFFF', 'stroke-width': 1.2 });
      [-1, 1].forEach(function (s) {
        add('path', { d: 'M118 57 l' + (9 * s) + ' -6 M118 59 l' + (10 * s) + ' 1 M118 61 l' + (9 * s) + ' 7', fill: 'none', stroke: '#1B0F36', 'stroke-width': 2 });
      });
      add('circle', { cx: 118, cy: 58, r: 6.5, fill: '#1B0F36', stroke: '#1B0F36' });
      add('circle', { cx: 116, cy: 57, r: 1.2, fill: '#FFFFFF', 'stroke-width': 0 });
      add('circle', { cx: 120, cy: 57, r: 1.2, fill: '#FFFFFF', 'stroke-width': 0 });
    }
    // friendly ghost
    add('path', { d: 'M38 176 v-44 a22 22 0 0 1 44 0 v44 l-7 -7 -7 7 -8 -7 -7 7 -8 -7z', fill: '#FFFFFF' });
    add('ellipse', { cx: 52, cy: 128, rx: 3.5, ry: 5, fill: INK, 'stroke-width': 0 });
    add('ellipse', { cx: 68, cy: 128, rx: 3.5, ry: 5, fill: INK, 'stroke-width': 0 });
    if (!changed) add('ellipse', { cx: 60, cy: 149, rx: 5, ry: 6, fill: INK, 'stroke-width': 0 });      // 3 ghost's mouth
    add('circle', { cx: 46, cy: 139, r: 3, fill: '#FFB3D1', 'stroke-width': 0 });
    add('circle', { cx: 74, cy: 139, r: 3, fill: '#FFB3D1', 'stroke-width': 0 });
    // pumpkins
    pumpkin(150, 186, 17, '#FF7A1A');
    pumpkin(232, 184, 22, changed ? '#9B6BE8' : '#FF7A1A');                                            // 4 pumpkin colour
    return svg;
  }
  var DIFFS_HALLOWEEN = [
    { x: 246, y: 46, r: 30, label: 'The moon' },
    { x: 178, y: 66, r: 24, label: 'A bat' },
    { x: 60, y: 149, r: 12, label: 'The ghost' },
    { x: 232, y: 182, r: 30, label: 'A pumpkin' },
    { x: 118, y: 52, r: 20, label: 'A spider' }
  ];


  function announce(root, msg) {
    var live = root.querySelector('[data-bb-live]');
    if (live) live.textContent = msg;
  }

  function initSpot(root) {
    var a = root.querySelector('[data-bb-pic-a]');
    var b = root.querySelector('[data-bb-pic-b]');
    var countEl = root.querySelector('[data-bb-count]');
    var winEl = root.querySelector('[data-bb-win]');
    var DIFFS = DIFFS_HALLOWEEN;
    var found;

    function mark(svg, d) {
      svg.appendChild(el('circle', { cx: d.x, cy: d.y, r: d.r, fill: 'none', stroke: '#FFD43B', 'stroke-width': 4, 'class': 'bb-spot__ring' }));
    }

    function build() {
      found = {};
      a.textContent = ''; b.textContent = '';
      var sa = sceneHalloween(false), sb = sceneHalloween(true);
      a.appendChild(sa); b.appendChild(sb);
      [sa, sb].forEach(function (svg) {
        svg.addEventListener('click', function (e) {
          var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
          var p = pt.matrixTransform(svg.getScreenCTM().inverse());
          DIFFS.forEach(function (d, i) {
            if (found[i]) return;
            var dx = p.x - d.x, dy = p.y - d.y;
            if (dx * dx + dy * dy <= d.r * d.r) {
              found[i] = true; mark(sa, d); mark(sb, d);
              var n = Object.keys(found).length;
              countEl.textContent = String(n);
              announce(root, d.label + ' is different! ' + n + ' of ' + DIFFS.length + ' found.');
              if (n === DIFFS.length && winEl) winEl.hidden = false;
            }
          });
        });
      });
      countEl.textContent = '0';
      if (winEl) winEl.hidden = true;
    }

    root.querySelector('[data-bb-hint]').addEventListener('click', function () {
      for (var i = 0; i < DIFFS.length; i++) {
        if (!found[i]) {
          var svgB = b.querySelector('svg');
          var h = el('circle', { cx: DIFFS[i].x, cy: DIFFS[i].y, r: DIFFS[i].r, fill: 'rgba(255,212,59,0.35)', stroke: 'none', 'class': 'bb-spot__hint' });
          svgB.appendChild(h);
          setTimeout(function () { h.remove(); }, 1500);
          announce(root, 'Look near: ' + DIFFS[i].label.toLowerCase());
          return;
        }
      }
    });
    root.querySelector('[data-bb-reset]').addEventListener('click', build);
    build();
  }

  function initAll() {
    document.querySelectorAll('[data-bb-activity="spot-halloween"]').forEach(function (root) {
      if (root.dataset.bbReady) return;
      root.dataset.bbReady = '1';
      initSpot(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
